import { FloatingFormItem, InputDate } from '@/components/_common';
import { WorkOrderItem } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import { Form, message, Modal, ModalProps, Table } from 'antd';
import { Moment } from 'moment';
import { useState } from 'react';

export type FutureServiceImportExludedValues = {
  itemIds: number[];
  date: string;
};

interface Props extends Omit<ModalProps, 'onOk'> {
  onCancel: () => void;
  onOk: (values: FutureServiceImportExludedValues) => void;
  items?: WorkOrderItem[];
}

const FutureServiceImportExcludedModal: React.FC<Props> = ({
  items,
  ...props
}) => {
  const [itemIds, setItemIds] = useState<number[]>([]);
  const ruleRequired = useDefaultEmptyFieldError();
  const [form] = Form.useForm<{ date: Moment }>();

  return (
    <Modal
      {...props}
      title="Importar serviços excluídos"
      okText="Importar"
      onOk={async () => {
        try {
          if (!itemIds.length) {
            return message.warning('Selecione pelo menos 1 serviço!');
          }
          const values = await form.validateFields();
          props.onOk({ itemIds, date: values.date.format(DateTimeFormat) });
        } catch {}
      }}
      okButtonProps={{ disabled: props.confirmLoading || !itemIds.length }}
      destroyOnClose
    >
      <p>
        Selecione abaixo os serviços excluídos que deseja importar do orçamento.
      </p>

      <Form form={form}>
        <FloatingFormItem
          name="date"
          label="Data do serviços"
          rules={[ruleRequired]}
        >
          <InputDate />
        </FloatingFormItem>

        <p>
          <strong>Serviços</strong>
        </p>

        <Table
          dataSource={items}
          columns={[{ dataIndex: 'description', title: 'Descrição' }]}
          rowSelection={{
            selectedRowKeys: itemIds,
            onChange: (keys) => setItemIds(keys as number[]),
          }}
          rowKey={(row) => row.id}
          pagination={false}
        />
      </Form>
    </Modal>
  );
};

export default FutureServiceImportExcludedModal;
